import ValidatorInterface from '../interface/Validator';
import { triggerCustomEvent } from "../EventTrigger";

export default class Validator implements ValidatorInterface
{
    protected rules: object = {};
    protected messages = {
        required: 'Это поле обязательно для заполнения',
        cyrillic: 'Вы ввели недопустимый символ, используйте только символы кириллицы',
        phone: 'Укажите телефонный номер в формате +7 (ХХХ) ХХХ-ХХ-ХХ',
        country_phone: 'Укажите телефонный номер в соответствии с шаблоном',
        text: 'Вы используете недопустимые символы',
        email: 'Укажите email-адрес в формате xxx@xxx.xx',
    };

    constructor(config: object = {})
    {
        for (let field in config) {
            this.rules[field] = config[field];
        }
    }

    public run(form: string|HTMLFormElement): boolean
    {
        if (typeof form === 'string') {
            form = document.getElementById(form) as HTMLFormElement;
        }

        let isValid = true;

        form.querySelectorAll('input[name], textarea[name]').forEach(inputNode => {
            let input = inputNode as HTMLInputElement;
            this.message(input, '');

            if (input.type === 'hidden' || !isValid) {
                return;
            }

            isValid = isValid && this.validate(input);
        });

        return isValid;
    }

    public validate(input: HTMLInputElement): boolean
    {
        let message = '';
        let isInputValid = this.validateInput(input, 'required');

        if (isInputValid) {
            let validation = this.getValidationType(input);
            isInputValid = this.validateInput(input, validation);

            if (!isInputValid) {
                message = this.messages[validation];
            }
        } else {
            message = this.messages.required;
        }

        this.message(input, message);

        if (isInputValid) {
            input.classList.remove('form__input_error');
            input.classList.add('form__input_validated');
        } else {
            input.classList.add('form__input_error');
            input.classList.remove('form__input_validated');
            input.focus();
            triggerCustomEvent(input, 'non-validated-field');
        }

        return isInputValid;
    }

    public message(input: HTMLInputElement, message: string = '')
    {
        let parent = input.parentElement;
        let messageNode = parent.querySelector('.validation__message');
        
        parent.classList.add('validation');
        
        if (messageNode === null) {
            messageNode = document.createElement('div');
            messageNode.classList.add('validation__message', 'validation_error');
            parent.appendChild(messageNode);
        }

        if (message === '') {
            messageNode.classList.remove('validation_active');
        } else {
            messageNode.classList.add('validation_active');
        }

        messageNode.innerHTML = message;
    }

    protected getValidationType(input: HTMLInputElement): string
    {
        let validation = '';
        
        if (input.name in this.rules) {
            validation = this.rules[input.name];
        };

        if (typeof input.dataset.validation !== 'undefined') {
            validation = input.dataset.validation;
        }

        return validation;
    }

    protected validateInput(input: HTMLInputElement, validation: string): boolean
    {
        if (validation == '') {
            return true;
        }

        let isValid = false;

        switch (validation) {
            case 'required':
                isValid = !input.hasAttribute('data-required') || input.value !== '';
                break;
                
            case 'cyrillic':
                isValid = input.value.search(/^[а-я ё\-]*$/i) !== -1;
                break;

            case 'phone':
                isValid = input.value.search(/^\+7 \(\d{3}\) \d{3}-\d\d-\d\d+$/) !== -1;
                break;

            case 'country_phone':
                isValid = input.dataset.valid === 'true';
                break;
    
            case 'text':
                isValid = input.value.search(/^[а-я\s\w\dё.,!?:;*%()+\-]*$/i) !== -1;
                break;

            case 'email':
                isValid = input.value.search(/^[a-z\d-_.]+@[a-z\d-_.]+\.[a-z\d]+$/i) !== -1;
                break;
        }

        return isValid;
    }
}
